import { useEffect, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { IoMdAddCircle } from "react-icons/io";
import { useSessionStorage } from "react-use";
import swalFormErrorMessage from "../../../../modules/pages/newLetter/functions/swalFormErrorMessage";
import style from "./ShipmentSection.module.css";
import DetailBox from "./components/DetailBox";
import ShipmentForm from "./components/ShipmentForm";
import detectDiryFields from "./functions/detectDiryFields";
import generateRandomString from "./functions/generateRandomString";

function ShipmentSectionAvaShop({
  lastPartNumber = 100,
  company,
  senderAddress,
}) {
  const [formValues, setFormValues] = useState({
    count: 0,
    values: null,
  });

  const baseInfoShipment = {
    packaging: 0,
    cost: 20000000,
    isFragile: false,
    isLiquid: false,
    ui: generateRandomString(),
    serviceInPlace: 0,
    needPackaging: false,
    content: [{ key: generateRandomString() }],
  };

  const [shipments, setShipments] = useSessionStorage("shipmentsAvaShop", [
    baseInfoShipment,
  ]);

  const [prices, setPrices] = useState([]);

  const {
    register,
    handleSubmit,
    formState: { errors, dirtyFields },
    control,
    getValues,
    watch,
    reset,
    setValue,
    unregister,
  } = useForm();

  const { fields, remove, insert, append } = useFieldArray({
    name: "items",
    control,
  });

  useEffect(() => {
    shipments.forEach(item => append(item, { shouldFocus: false }));
  }, []);

  useEffect(() => {
    setPrices([]);
  }, [company, senderAddress]);

  useEffect(() => {
    setShipments(getValues("items"));
  }, [getValues()]);

  return (
    <section className="pt-3">
      <p className="title-style">مشخصات مرسوله</p>
      <button
        className={"buttonUi rounded-1 f-center " + style.addBtn}
        onClick={() => append(baseInfoShipment)}
      >
        <span className="ms-3">افزودن</span>
        <span className="fs-4">
          <IoMdAddCircle />
        </span>
      </button>

      <form
        id="formShop"
        onKeyDown={e => {
          if (e.key === "Enter" && e.target.nodeName === "INPUT") {
            const form = e.target.form;
            if (form?.elements === undefined) return;

            const index = Array.prototype.indexOf.call(form.elements, e.target);
            if (form.elements[index + 1]) {
              form.elements[index + 1].focus();
            }
            e.preventDefault();
          }
        }}
        onSubmit={handleSubmit(
          values => setFormValues(cur => ({ count: cur.count + 1, values })),
          errors => swalFormErrorMessage(errors.items)
        )}
      >
        {fields.map((item, idx) => (
          <ShipmentForm
            key={item.ui}
            index={idx}
            register={register}
            shipment={item}
            errors={errors?.items ? errors?.items[idx] : {}}
            remove={remove}
            getValues={getValues}
            insert={insert}
            lastPartNumber={lastPartNumber}
            watch={watch}
            control={control}
            setValue={setValue}
            isDirty={detectDiryFields(dirtyFields, idx)}
            unregister={unregister}
            priceState={{ prices, setPrices }}
          />
        ))}

        <DetailBox
          shipments={getValues("items") ?? []}
          reset={reset}
          formValues={formValues}
          prices={prices}
          setPrices={setPrices}
        />
      </form>
    </section>
  );
}

export default ShipmentSectionAvaShop;
